module.exports = __webpack_public_path__ + "0be14c56554d2d9d9bc7a6abcb9e35a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.png
// module id = 2018
// module chunks = 0